export default "__VITE_ASSET__DUhBygkT__"